/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from "@emotion/core";
import React from 'react'
import { Modal } from 'react-bootstrap'

const ConnectConfirmModal = ({ show = true, onHide, theme }) => {
  return (
    <Modal show={show} onHide={onHide} className="colorPicker-model">
        <Modal.Body>
        <div className="full-model md-model-updates w-[480px]">
            <div className="full-model-body">
                <div className="body-data bg-white rounded-25">
                    <div className='ctTitle relative flex flex-col items-start gap-[2px]'>
                        <span className='darkPrimaryColor'>Success!</span>
                    </div>
                    <div className='flex flex-col py-[30px] px-10 gap-[10px] justify-start items-start w-full'>
                        <p className='flex items-center gap-[10px] font text-[14px] text-black'>A two-way sync has been established between your Lifetab and Todoist accounts.</p>
                        <p className='flex items-center gap-[10px] font text-[14px] text-black'>Tasks you create and edit in one app will automatically be reflected in the other app.</p>
                        <button className={`button primary mt-5 text-white`} onClick={onHide} css={{background: `var(--accent-color)`}}>Continue</button>
                    </div>
                </div>
            </div>
        </div>
        </Modal.Body>
    </Modal>
  )
}

export default ConnectConfirmModal